import React, { Component } from 'react';

import * as MuiCore from '@material-ui/core';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import UserProfile from './UserProfile';

import * as coreSelectors from '../core/selectors';
import * as accountSelectors from '../account/selectors';
import { withRouter } from 'react-router-dom'

const styles = theme => ({
    root: {
        // padding: theme.spacing(1),
        // minHeight: '100%',
        flexGrow: 1,
        display:'flex',
    },

    flexContainer:{
        // minHeight: '100%',
        display: 'flex',
        flexDirection: "column",
    },  
    
    leftSide:{
        overflow:'auto',
        padding: theme.spacing(1),
        flexGrow: 1,
        // minHeight: '100%',
        display:'flex',
    },

    flexItemRoot: {
        // these are flex items
        
        // flex: 1; same as:
        flexGrow: 1,
        // flex-shrink: 1;
        // flex-basis: auto;
        // flex: 1 1 auto;
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
})

class Profile extends Component {
    state = {
        mouseState: 'left'
    }

    componentDidMount(){
        document.title = 'Ruby - Account';
    }

    checkPermission = () => {
        if(this.props.user.userAccountRoles.filter(account => account.accountId === this.props.accountId)[0]?.userRoleKey === 'GLOBALADMIN'){
            return true;
        }
        return false;
    }

    // If any one of the accounts have GLOBALADMIN then show billing and insights
    // if not hide them
    checkUserRoles = () => {
        var globalAdmins = this.props.user.userAccountRoles.filter(account => account.userRoleKey === 'GLOBALADMIN').length || 0;
        return globalAdmins > 0;
    }

    checkPartner = () => {
        return this.props.user.userAccountRoles.filter(user => user.userRoleKey === 'PARTNERS' || user.userRoleKey === 'GRASSHOPPER' || user.userRoleKey === 'GRASSHOPPERSMS' || user.userRoleKey === 'BILLING_ADMIN').length > 0;
    }

    checkBillingAdmin = () => {
        return this.props.user.userAccountRoles.filter(user => user.userRoleKey === 'BILLING_ADMIN').length > 0;
    }

    showIntegration = () => {
        return this.props.user.userAccountRoles.filter(user => user.userRoleKey === 'GLOBALADMIN' || user.userRoleKey === 'GRASSHOPPERGLOBAL').length > 0;
    }

    render() {
        const {classes, history} = this.props;

        return (
            <MuiCore.Grid container className={classes.root}>
                <MuiCore.Grid item lg={12} md={12} className={classes.flexContainer}>
                    <MuiCore.Grid container className={classes.leftSide} spacing={2}>
                        <UserProfile className={classes.flexItemRoot} />
                    </MuiCore.Grid>
                </MuiCore.Grid>
                <MuiCore.Grid item lg={12} md={12} className={classes.flexContainer}>
                <MuiCore.Divider style={{margin:50}}/>
                </MuiCore.Grid>
                <MuiCore.Grid item lg={12} md={12} className={classes.flexContainer}>
                <div style={{display: 'flex',justifyContent: 'space-evenly'}}>
                    {!this.checkBillingAdmin() && <img alt='' src="https://my.ruby.com/assets/img/account-company.svg" style={{cursor: 'pointer'}} onClick={()=>history.push('/company')}/>}
                    {!this.checkBillingAdmin() && <img alt='' src="https://my.ruby.com/assets/img/account-settings.svg" style={{cursor: 'pointer'}} onClick={()=>history.push('/settings')}/>}
                    {!this.checkPartner() && this.checkUserRoles() && <img alt='' src="https://my.ruby.com/assets/img/insights-icon-with-text.svg" style={{cursor: 'pointer'}} onClick={()=>history.push('/reports')}/>}
                    {!this.checkPartner() && this.checkUserRoles() && <img alt='' src="https://my.ruby.com/assets/img/account-billing.svg" style={{cursor: 'pointer'}} onClick={()=>{history.push('/billing')}}/>}
                    {!this.checkBillingAdmin() && this.showIntegration() && <img alt='' src="https://my.ruby.com/assets/img/avvount-integrations.svg" style={{cursor: 'pointer'}} onClick={()=>history.push('/integrations')}/>}
                </div>
                </MuiCore.Grid>

                <MuiCore.Grid style={{ display: 'flex',
                                        justifyContent: 'center',
                                        position: 'fixed',
                                        bottom: 0,
                                        left: 0,
                                        width: '100%',
                                        marginBottom: 20 }}>
                    <MuiCore.Grid style={{ alignItems: 'center', textAlign: 'center' }}>
                        <MuiCore.Typography style={{ fontFamily: 'Sofia', fontSize: 14 }}>
                        © 2023 Ruby. All Rights Reserved. Ruby is a registered trademark of Ruby Receptionists, Inc.
                        <span> | </span>
                        <span style={{fontFamily: 'Sofia-bold', fontSize: 14, color: this.state.mouseState === 'termsAndConditions' ? '#E5196C' : '#09122B', fontWeight: 400, cursor: 'pointer', textDecoration: 'underline'}} onClick={() => {window.open("https://www.ruby.com/terms/");}} onMouseEnter={()=>{this.setState({mouseState: 'termsAndConditions'})}} onMouseLeave={()=>{this.setState({mouseState: 'left'})}}>
                            {'Terms and Conditions'}
                        </span>
                        <span> | </span>
                        <span style={{fontFamily: 'Sofia-bold', fontSize: 14, color: this.state.mouseState === 'privacyPolicy' ? '#E5196C' : '#09122B', fontWeight: 400, cursor: 'pointer', textDecoration: 'underline'}} onClick={() => {window.open("https://www.ruby.com/privacy/");}} onMouseEnter={()=>{this.setState({mouseState: 'privacyPolicy'})}} onMouseLeave={()=>{this.setState({mouseState: 'left'})}}>
                            {'Privacy Policy'}
                        </span>
                        </MuiCore.Typography>
                    </MuiCore.Grid>
                </MuiCore.Grid>
                
                {/* <MuiCore.Grid item lg={12} md={12} className={classes.flexContainer}>
                    <MuiCore.Grid lg={6} style={{alignSelf: 'center'}}>
                        <MuiCore.Grid container className={classes.leftSide} spacing={2}>
                            <AccountSelect className={classes.flexItemRoot} addUserRoles='Y'/>
                        </MuiCore.Grid>
                    </MuiCore.Grid>
                </MuiCore.Grid> */}
                {/* <MuiCore.Grid item lg={6} md={12} className={classes.flexContainer}>
                    <MuiCore.Grid container className={classes.leftSide} spacing={2}>
                        <UserProfile className={classes.flexItemRoot} />
                    </MuiCore.Grid>
                </MuiCore.Grid> */}
                {/* <MuiCore.Grid item lg={6} md={12} className={classes.flexContainer}>
                    <MuiCore.Grid container className={classes.leftSide} spacing={2}>
                        <CompanyProfile className={classes.flexItemRoot} />
                    </MuiCore.Grid>
                </MuiCore.Grid> */}
                {/* <MuiCore.Grid item lg={12} md={12} className={classes.flexContainer}>
                    <MuiCore.Grid container className={classes.leftSide} spacing={2}>
                        <Plans className={classes.flexItemRoot} />
                    </MuiCore.Grid>
                </MuiCore.Grid> */}
                {/* <MuiCore.Grid item lg={this.checkPermission() ? 6 : 12} md={12} className={classes.flexContainer}>
                    <MuiCore.Grid container className={classes.leftSide} spacing={2}>
                        <UserDirectory className={classes.flexItemRoot} />
                    </MuiCore.Grid>
                </MuiCore.Grid> */}
                {/* {this.checkPermission() && <MuiCore.Grid item lg={6} md={12} className={classes.flexContainer}>
                    <MuiCore.Grid container className={classes.leftSide} spacing={2}>
                        <CallerIds className={classes.flexItemRoot}/>
                    </MuiCore.Grid>
                </MuiCore.Grid>} */}
            </MuiCore.Grid>
            )

    }
    
}

const mapStateToProps = (state) => {
    return ({
        user : coreSelectors.getUser(state),
        accountId : accountSelectors.getAccountId(state)
    });
};

const mapDispatchToProps = {

};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Profile)));